import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "vue";

import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { ApiService, SnackbarService } from "@/services";
import { useBriefcaseStore } from "@/pinia/briefcase";
import {
  BriefcaseActions,
  SearchItem,
  SearchResponseRecordType,
  VignetteHelpers,
} from "@/types";
import BriefcaseFolderMoveDialog from "@/components/BriefcaseFolderMoveDialog.vue";

export interface MinimumBriefcaseKeys {
  id: number;
  briefcaseItemId: number;
  addedToBriefcase: boolean;
  longName?: string;
  preferredNameDisplay?: string;
  recordType: SearchResponseRecordType;
  positionSummary?: string;
  title?: string;
  quickSummary?: string;
  headshot?: string;
}

interface Props {
  item: MinimumBriefcaseKeys;
  useIconOnly?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AddToBriefcaseButton',
  props: {
    item: null,
    useIconOnly: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  item: MinimumBriefcaseKeys;
  useIconOnly?: boolean;
};


const iconOnly = computed(() => props.useIconOnly || false);

const briefcaseStore = useBriefcaseStore();
const { isInBriefcase } = briefcaseStore;
const isAddedToBriefcase = isInBriefcase(props.item.briefcaseItemId);

const {
  id,
  briefcaseItemId,
  preferredNameDisplay,
  longName,
  recordType: type,
} = toRefs(props.item);

const toggleBriefcase = async () => {
  if (id.value) {
    const searchItem: SearchItem = {
      subscriptionModules: [],
      positionSummary: props.item.positionSummary || "",
      title: props.item.title || "",
      quickSummary: props.item.quickSummary || "",
      headshot: props.item.headshot || "",
      isFormer: false,
      id: id.value,
      briefcaseItemId: briefcaseItemId.value,
      preferredNameDisplay:
        preferredNameDisplay?.value || longName?.value || "",
      addedToBriefcase: isAddedToBriefcase.value,
      politicalParty: "",
      recordType: type.value,
    };

    if (isAddedToBriefcase.value) {
      const folders = briefcaseStore.getFolderIdsById(
        searchItem.briefcaseItemId
      ).value;

      if (folders.length > 1) {
        briefcaseStore.meta.itemBeingMoved = searchItem;
        VignetteHelpers.Analytics.push({
          ["event"]: "briefcase-move-items",
          ["custom.gtm.itemId"]: searchItem.id,
          ["custom.gtm.itemType"]: "Profile",
        });
      } else {
        await ApiService.postBriefcaseToggle(
          [searchItem],
          BriefcaseActions.REMOVE
        );
        VignetteHelpers.Analytics.push({
          ["event"]: "briefcase-remove-items",
          ["custom.gtm.itemId"]: searchItem.id,
          ["custom.gtm.itemType"]: "Profile",
        });
        SnackbarService.displaySnackbar(
          `${searchItem.preferredNameDisplay} removed from Briefcase.`,
          "primary"
        );
      }
    } else {
      const result = await ApiService.postBriefcaseToggle(
        [searchItem],
        BriefcaseActions.ADD
      );
      VignetteHelpers.Analytics.push({
        ["event"]: "briefcase-add-items",
        ["custom.gtm.itemId"]: searchItem.id,
        ["custom.gtm.itemType"]: "Profile",
      });
      if (result) {
        SnackbarService.displaySnackbar(
          `${searchItem.preferredNameDisplay} added to Briefcase.`,
          "primary",
          3000,
          searchItem
        );
      } else {
        SnackbarService.displaySnackbar(
          `You have too many profiles in your briefcase, try moving them around.`,
          "error",
          -1,
          searchItem
        );
      }
    }
  }
};

return { __sfc: true,props, iconOnly, briefcaseStore, isInBriefcase, isAddedToBriefcase, id, briefcaseItemId, preferredNameDisplay, longName, type, toggleBriefcase, NjBtn, BriefcaseFolderMoveDialog }
}

})